import { getReportSignedUrl, ReportSignedUrlQueryArgs } from '@/api/reports';

export const getReportFileQuery = async (args: ReportSignedUrlQueryArgs) => {
    return getReportSignedUrl(args)
        .then((response) => response.signedUrl)
        .then((fileSignedUrl) => fetch(fileSignedUrl))
        .then((response) => response.blob());
};
